import React from 'react';
import { ARCHETYPES, ARCHETYPE_KEYS } from '../data/archetypes';
export function ArchetypeChips() {
  return <ul className="mx-auto flex max-w-xl flex-wrap justify-center gap-2" aria-label="The eight relational archetypes" data-id="element-8" data-mp="kqf7lyp1qp2j">
      {ARCHETYPE_KEYS.map(key => <li key={key} data-id="element-9" data-mp="uhjionblpps3">
          <span className="flex items-center gap-2 rounded-full border border-border bg-cream-light px-3.5 py-1.5 text-[13px] text-ink-light" data-id="element-10" data-mp="uib5p9r4uf6r">
            <span aria-hidden="true" data-id="element-11" data-mp="6ts0x47akkjf">{ARCHETYPES[key].emoji}</span>
            {ARCHETYPES[key].name}
          </span>
        </li>)}
    </ul>;
}